// Ensures that a number is between a minimum and maximum value.
export const clamp = (value: number, min: number, max: number): number => {
  if (value == null) value = 0;
  return Math.min(Math.max(value, min), max);
};

export const roundAwayFromZero = (value: number, decimals: number = 2): number => {
  if (value === 0 || value === null) return 0;
  
  const factor = Math.pow(10, decimals);
  const scaledValue = value * factor;
  
  // Implementation of "Away From Zero" rounding:
  // If the value is positive, we use Math.ceil for the midpoint
  // If the value is negative, we use Math.floor for the midpoint
  const direction = value > 0 ? 1 : -1;
  
  // Handle the midpoint case specifically
  const scaledAbs = Math.abs(scaledValue);
  const isExactlyHalf = Math.abs(scaledAbs - Math.floor(scaledAbs) - 0.5) < Number.EPSILON;
  
  if (isExactlyHalf) {
    // At midpoint, round away from zero
    return direction * Math.ceil(scaledAbs) / factor;
  } else {
    // Not at midpoint, use standard rounding
    return Math.round(scaledValue) / factor;
  }
}